 
import theme from '../../themes/index.en';

const { palette, spacing, typography } = theme;

const CustomDataTableStyles = {
  paper: { 
    overflow: 'hidden', 
    marginBottom: '40px'
  },
  tableContainer: { 
    overflowX: 'auto',
  },
  tableHeadCell: {
    fontWeight: 'bold',
    backgroundColor: palette.primary.main,
    color: palette.common.white, 
    fontSize: typography.subtitle1.fontSize, 
  },
  childRow: {
    bgcolor: theme.palette.action.focus 
  },
  childCell: {
    color: theme.palette.primary.main
  },
  paginatedTableHeadCell: {
    background: palette.primary.main,
    color: palette.text.secondary, 
    fontSize: typography.subtitle1.fontSize,
  },
  stickyHeader: { 
    position: 'sticky' as 'sticky',
    left: 0,
    zIndex: 100, 
  },
  stickyColumn: { 
    position: 'sticky' as 'sticky',
    left: 0,
    zIndex: 100,
    background: palette.background.paper,
  },
  tableRowCell: { 
    backgroundColor: palette.secondary.light,
    color: palette.secondary.main, 
  },
  tableBody: { 
    backgroundColor: palette.action.hover, 
  }, 
  paginatedTableRow: {
    backgroundColor: palette.background.default,  
  },
  tablePagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: `1px solid ${palette.action.disabled}`,
    padding: spacing(2),
    backgroundColor: palette.action.hover,
  },
  groupHeaderRow: {
    background: palette.background.paper,
  },
  groupHeaderCell: {
    fontWeight: 'bold',
    fontSize: '16px',
    background: palette.background.paper,
  },

};

export default CustomDataTableStyles;
